import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import { Hero, CategoriesSection, ProductRail } from "@/components/home/ProductRails";
import {
  WhyChoose, GallerySection, AboutSection, HowToBuy, OrderSteps,
  DeliverySection, TestimonialsSection, InstagramSection, GiftBanner, FaqSection, WhatsAppCTA,
} from "@/components/home/Sections";
import { useStore } from "@/context/StoreContext";

export default function Home() {
  const { content } = useStore();
  const sections = content?.sections || [];

  const renderSection = (key) => {
    switch (key) {
      case "hero": return <Hero key={key} />;
      case "categories": return <CategoriesSection key={key} />;
      case "featured_products": return (
        <ProductRail key={key} id="destaques"
          title={content?.featured_section?.title || "Produtos em destaque"}
          subtitle={content?.featured_section?.subtitle}
          filter={{ featured: "true" }} />
      );
      case "best_sellers": return (
        <ProductRail key={key} id="queridinhos"
          title={`🔥 ${content?.best_sellers_section?.title || "Queridinhos da Art3D"}`}
          subtitle={content?.best_sellers_section?.subtitle}
          filter={{ badge: "mais_vendido" }} />
      );
      case "new_arrivals": return (
        <ProductRail key={key} id="novidades"
          title={`✨ ${content?.new_arrivals_section?.title || "Acabaram de chegar!"}`}
          subtitle={content?.new_arrivals_section?.subtitle}
          filter={{ badge: "novidade" }} />
      );
      case "why_choose": return <WhyChoose key={key} />;
      case "gallery": return <GallerySection key={key} />;
      case "about": return <AboutSection key={key} />;
      case "how_to_buy": return <HowToBuy key={key} />;
      case "order_steps": return <OrderSteps key={key} />;
      case "delivery": return <DeliverySection key={key} />;
      case "testimonials": return <TestimonialsSection key={key} />;
      case "instagram": return <InstagramSection key={key} />;
      case "gift_banner": return <GiftBanner key={key} />;
      case "faq": return <FaqSection key={key} />;
      case "whatsapp_cta": return <WhatsAppCTA key={key} />;
      default: return null;
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        {sections.length
          ? sections.filter((s) => s.enabled).map((s) => renderSection(s.key))
          : <Hero />}
      </main>
      <Footer />
      <CartDrawer />
      <WhatsAppFloat />
    </div>
  );
}
